// Live-Zuordnung der finanziellen Unterstützung im VA-Formular (DCP-2228
// follow-up, 14.09.2026) — Spiegel von
// backend/src/events/refund/financial-support-matching.ts's
// resolveFinancialSupport(), damit die Anzeige im Formular sofort reagiert,
// ohne für jede Tastatureingabe an den Server zu fragen. Die eigentliche
// Berechnung bei der Abrechnung bleibt serverseitig — das hier ist nur die
// Vorschau im Formular.

import type { EventAudience, FinancialSupport } from '@/types';

/** Der passende Eintrag für diesen VA-Typ/Teilnehmerkreis, falls einer gepflegt ist. */
export function resolveFinancialSupport(
  entries: readonly FinancialSupport[],
  vaType: string,
  audience: EventAudience
): FinancialSupport | undefined {
  return entries.find((e) => e.audience === audience && e.vaTypes.includes(vaType));
}
